// Tanner Fry
// tannerf1101@yahoo.com
// Common API calls.

import { getCorrectDomain } from '../AppSettings';
import { SubscriptionPlan } from '../assets/components/data/SubscriptionData';

export interface ReturnPropsAPIGetUserSubscriptionPlanResponse {
    subscriberPlan: SubscriptionPlan,
    errorMessage: string
}

export const APIGetUserSubscriptionPlanResponse = async (userEmail: string) => {
    // await checkUserDetailsAndToken().catch((error) => {
    //     console.warn("Error in checkUserDetailsAndToken:", error);
    //     return null;
    // });
    
    let returnUserPlan: ReturnPropsAPIGetUserSubscriptionPlanResponse = {
        subscriberPlan: SubscriptionPlan.Free,
        errorMessage: ''
    }
    
    return fetch(getCorrectDomain() + '/api/users/is-subscriber', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userUuid: JSON.parse(localStorage.getItem('user')).uuid,
            email: userEmail,
        })
    }).then(function (response) {
        if (response.ok) {                    
            return response.json();
        }
        return Promise.reject(response);
    }).then(async function (response) {                
        if (response[0].result === "Success") {
            returnUserPlan = {
                subscriberPlan: response[0].data.plan,
                errorMessage: ''
            };
            return returnUserPlan;
        } else {
            // TODO: Display message to user, error getting subscription plan.
            // console.log("Subscriber Result: ", JSON.stringify(response));
            // console.log("Subscriber email: ", userEmail);
            
            returnUserPlan = {
                subscriberPlan: SubscriptionPlan.Free,
                errorMessage: response[0].message
            };
            return returnUserPlan;
        }
    }).catch(function (error) {
        console.warn('Something went wrong with api subscriber check.', error);
        returnUserPlan = {
            subscriberPlan: SubscriptionPlan.Free,
            errorMessage: error
        };
        return returnUserPlan;
    });
};

// api/users/admin/add
export const APIGETServerNotification = async () => {
    // await checkUserDetailsAndToken().catch((error) => {
    //     console.warn("Error in checkUserDetailsAndToken:", error);
    //     return null;
    // });
    
    return fetch(getCorrectDomain() + '/api/notify', {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }).then(function (response) {        
        if (response.ok) {
            // console.log("APIGETServerNotification response: ", response);
            return response.json();
        }
        return Promise.reject(response);
    }).then(function (data) {
        // console.log("Fetched new server notification: " + JSON.stringify(data));
        return data[0];
    }).catch(function (error) {
        console.warn('Something went wrong.', error);
    });
}

// api/subscriptions/feature/auth
export const APIPOSTSubscriptionsFeatureAuth = async (userUuid: string, feature: string, subFeature: string) => {
    // await checkUserDetailsAndToken().catch((error) => {
    //     console.warn("Error in checkUserDetailsAndToken:", error);
    //     return null;
    // });

    // console.log("APIPOSTSubscriptionsFeatureAuth userUuid: ", userUuid);
    
    return fetch(getCorrectDomain() + '/api/subscriptions/feature/auth', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).token,
        },
        body: JSON.stringify({
            uuid: userUuid,
            feature: feature,
            subFeature: subFeature
        })
    }).then(function (response) {        
        if (response.ok) {
            // console.log("APIGETSubscriptionsFeatureAuth response: ", response);
            return response.json();
        }
        return Promise.reject(response);
    }).then(function (data) {
        // console.log("Fetched new server feature auth: " + JSON.stringify(data));
        return data;
    }).catch(function (error) {
        console.warn('Something went wrong.', error);
        return undefined;
    });
}

// A generic API call that adds the userId to the body of the request. This should be the new norm for all API calls
// as it will allow us to easily add the userId to the request body without having to do it manually every time.
// This will also cut down on the amount of code needed to make an API call. SEE APIMain.tsx for an example.
export async function fetchAPIGET<ResultType>(endpointUrl: string): Promise<ResultType> {
    // await checkUserDetailsAndToken().catch((error) => {
    //     console.warn("Error in checkUserDetailsAndToken:", error);
    //     return null;
    // });

    // Check if token is valid
    await fetchAPIGETTokenIsValid();

    return fetch(getCorrectDomain() + endpointUrl, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).token,
        },
    }).then(function (response) {        
        if (response.ok) {                    
            return response.json();
        }
        return Promise.reject(response);
    }).then(async function (response) {
        if (response[0] as ResultType === null || response[0] as ResultType === undefined) {
            return response as ResultType;
        } else {
            return response[0] as ResultType;
        }
    }).catch(function (error) {
        console.warn('Something went wrong with api fetch.', error);
        return Promise.reject(error);
    });
}

export async function fetchAPIPOSTByUserUuid<ResultType>(endpointUrl: string, body: object): Promise<ResultType> {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user === null || user.token === null || user.uuid === null) {
        return Promise.reject("User is not logged in.");
    }

    // Check if token is valid
    await fetchAPIGETTokenIsValid();

    return fetch(getCorrectDomain() + endpointUrl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token,
        },        
        body: JSON.stringify({
            userUuid: user.uuid,
            ...body
        })
    }).then(async function (response) {  
        console.log("fetchAPIByUserId data with Bearer token from endpoint url: ", endpointUrl);
              
        if (response.ok) {       
            // Add status to json             
            let json = await response.json();
            json.status = response.status;
            return json;
        }
        return Promise.reject(response);
    }).then(async function (response) {
        try {
            if (response[0] as ResultType === null || response[0] as ResultType === undefined) {
                return response as ResultType;
            } else {
                return response[0] as ResultType;
            }
        } catch (error) {
            return response;
        }
    }).catch(function (error) {
        console.warn('Something went wrong with api fetch.', error);
        return Promise.reject(error);
    });
}

export const fetchAPIGETTokenIsValid = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user === null || user.token === null || user.uuid === null) {
        return Promise.reject("User is not logged in.");
    }

    // Check if token is valid
    let isValid = false;
    try {
        const response = await fetch(getCorrectDomain() + '/api/users/validate-token', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token,
            },
            body: JSON.stringify({
                userUuid: user.uuid,
            })
        });
        
        if (response.ok) {
            isValid = true;
            const tokenAuthResponse = await response.json();
            console.log("Token auth response: ", tokenAuthResponse);
        } else {
            console.log("User token is not valid.");
            isValid = false;
        }
        
        if (!isValid) {
            // Logout user and remove info. Our LeftMenu component checks if user is logged in and if not, it will redirect to login page.
            localStorage.removeItem('user');
            // Remove theme classes when user is logged out
            document.body.classList.remove('theme-light', 'theme-dark');
            window.location.reload();
            return Promise.resolve(null);
        }
    } catch (error) {
        // Handle network errors gracefully - don't reject, just log and continue
        console.warn('Something went wrong with api fetch token auth (network error).', error);
        // Don't reject on network errors - allow the calling function to handle it
        // Returning null allows the code to continue without breaking
        return Promise.resolve(null);
    } 
}

// const checkUserDetailsAndToken = () => {
//     return new Promise((resolve, reject) => {
//         const user = JSON.parse(localStorage.getItem('user'));
//         if (user === null) {
//             console.log("User is not logged in.");
//             reject("User is not logged in.");
//         } else if (user.token === null) {
//             console.log("User token is null.");
//             reject("User token is null.");
//         } else {
//             resolve(null);
//         }
//     });
// }